import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { AccessControlServiceConfig } from './access-control.service.types';

export function provideAccessControlService(config: AccessControlServiceConfig): EnvironmentProviders {
  return makeEnvironmentProviders([
    { provide: 'accessControlServiceConfig', useValue: config }
  ]);
}
